// extracted by mini-css-extract-plugin
export default {"Project":"Project_Project__s6Dz1","content":"Project_content__dWEbX","title":"Project_title__iR3hi","btnContainer":"Project_btnContainer__PNbzB"};